import { useCallback, useState } from 'react';
import { appEnv } from '../../_env';
import { cleanLocalStorage } from '../../_shared';
import { displayToast } from '../../_shared/components';
import { useIsLogged } from '../../user/hooks';

export function useLogout() {
   const [logoutLoading, setLogoutLoading] = useState(false);

   const { userLoading } = useIsLogged();

   const onLogoutClick = useCallback((return_to?: string) => {
      async function doLogout() {
         try {
            setLogoutLoading(true);

            const endpoint = appEnv.api.logoutBrowser;

            const data = await fetch(endpoint, {
               method: endpoint === appEnv.api.logoutBrowser ? 'GET' : 'POST',
               headers: {
                  Accept: 'application/json',
               },
               credentials: 'include',
            }).then((d) => d.json());

            if (data?.logout_url) {
               //2 api call to do the logout (injection localhost)
               const realLogoutUrl =
                  data?.logout_url.replace(new URL(data?.logout_url).origin, window.location.origin) +
                  `${return_to ? `&return_to=${encodeURIComponent(return_to)}` : ''}`;
               console.log('newApp logout_url', data?.logout_url);
               console.log('newApp return_to', return_to);
               console.log('newApp realLogoutUrl', realLogoutUrl);
               window.location.href = realLogoutUrl;
               return;
            } else {
               window.location.href =
                  // origin is already the login. hostname
                  `${window.location.origin}/login${return_to ? `?return_to=${encodeURIComponent(return_to)}` : ''}`;
               //throw new Error('Logout initialization error!');
            }
         } catch (e: unknown) {
            displayToast('error', 'Logout Failed!', (e as Error)?.message || 'Unknown Error');
            setLogoutLoading(false);
         }
      }
      cleanLocalStorage();
      doLogout();
   }, []);

   return {
      logoutLoading,
      userLoading,
      onLogoutClick,
   };
}
